import React, { useEffect, useRef, useState } from 'react';
import { MapModalContainer } from '../../containers/mapModal';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import './index.scss';

export default function ZoomMapModal({ url, isModalOpen, close }) {
  const imfRef = useRef(null);
  const [minScale, setminScale] = useState(1.5);
  useEffect(() => {
    if (window.screen.height > 700) {
      setminScale(1.74);
    }
  }, []);
  return (
    <MapModalContainer
      isModalOpen={isModalOpen}
      close={close}
      classname="map-modal"
    >
      <TransformWrapper
        initialScale={minScale}
        minScale={minScale}
        centerOnInit
        onInit={() => setminScale(minScale)}
      >
        <TransformComponent>
          <img ref={imfRef} src={`${url}&imwidth=2400`} alt="zara-img" />
        </TransformComponent>
      </TransformWrapper>
    </MapModalContainer>
  );
}
